import { IconVideoSquare } from '../icons';
const SquarePlayIcon = () => {
  return <button aria-label='Play Video' className='flex h-6 w-6 items-center justify-center rounded-full md:h-14 md:w-14' data-sentry-component="SquarePlayIcon" data-sentry-source-file="square-play-icon.tsx">
            <IconVideoSquare className='h-14 w-14 text-white' data-sentry-element="IconVideoSquare" data-sentry-source-file="square-play-icon.tsx" />
        </button>;
};
export default SquarePlayIcon;